module.exports = __webpack_public_path__ + "static/media/30OIOS2.ca0fca11.jpg";